import { Theme } from '@mui/material/styles';
import { css } from '@emotion/react';
import { FONT_SECONDARY } from '~/theme/typography';

const Container = (theme: Theme) => {
	const darkMode = theme.palette.mode === 'dark';

	return {
		MuiContainer: {
			styleOverrides: {
				root: css``,
			},
			defaultProps: {
				maxWidth: 'xl',
			},
		},
	};
};

export default Container;
